// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wk9y","textarea":"styles_textarea__3aDrB"};